export const dragPan = async (cy: any) => {
  return await cy.on('dragpan', () => {
    cy.container().style.cursor = 'all-scroll';
  });
};